module.exports = __webpack_public_path__ + "img/Github-512.b6fd3401.png";